import * as ActionTypes from '../constants/actionTypes'
import { sellerAddBalance } from '../api/seller'

export const editBalanceForm = formFieldsChange => ({
  type: ActionTypes.SELLERBALANCEFORM_EDITFORM_CHANGE,
  field: formFieldsChange,
})

export const reset = () => ({
  type: ActionTypes.SELLERBALANCEFORM_ENTER_RESET,
})

export const addItem = values => (dispatch) => {
  dispatch({ type: ActionTypes.SELLERBALANCEFORM_ADDITEM_LOAD })

  sellerAddBalance(values).then(() => {
    dispatch({ type: ActionTypes.SELLERBALANCEFORM_ADDITEM_SUCCEED })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.SELLERBALANCEFORM_ADDITEM_FAIL,
      addItemError: 'Ошибка пополнения баланса.',
    })
  })
}



// WEBPACK FOOTER //
// src/actions/sellerBalanceForm.js